/**
 * PIN 2 — pick the playback engine from probed browser capabilities.
 *
 * hls.js MUST be checked first. Safari reports BOTH `Hls.isSupported()` (MSE
 * since ~17) and `canPlayType('application/vnd.apple.mpegurl')`, so the ORDER
 * is what decides the engine. On iOS `Hls.isSupported()` is false, making
 * 'native' the only path — that is the branch a Safari regression hides in.
 *
 * Capability probing lives in the CALLER so this stays pure and testable.
 *
 * @param {{hlsSupported: boolean, canPlayNativeHls: boolean}} caps
 * @returns {'hlsjs'|'native'|'unsupported'}
 */
export function selectPlaybackMode(caps) {
  if (caps?.hlsSupported) {
    return 'hlsjs';
  }
  if (caps?.canPlayNativeHls) {
    return 'native';
  }
  return 'unsupported';
}

export default selectPlaybackMode;
